import { QPointMultiPolygon } from "@qpoint/utils";

export class QPointPagedMultiPolygon {
    constructor(
        public multiPolygon: QPointMultiPolygon,
        public page: number
    ) {}
}